import debounce from "lodash/debounce";
import "./dropdown.js";

window.Sparkle ??= {};

Sparkle.HeaderActionDropdown = class HeaderActionDropdown extends Sparkle.Dropdown {
  constructor(content, options) {
    const _options = jQuery.extend(
      {
        dropdownBackdrop: true,
      },
      options,
    );

    super(content, _options);
    this.dropdownBackdropClicked = this.dropdownBackdropClicked.bind(this);
    this.menuExpanderClicked = this.menuExpanderClicked.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.setDropdownBackdropHeight = this.setDropdownBackdropHeight.bind(this);
    this.getOffset = this.getOffset.bind(this);
    this.options = _options;

    if (this.options.dropdownBackdrop) {
      this.dropdownBackdrop = jQuery("<div class='dropdown-backdrop'></div>");
      this.dropdownMenu = this.dropdownBackdrop.append(this.dropdownMenu);
      this.dropdownBackdrop.on("click", this.dropdownBackdropClicked);
      jQuery(window).on("resize", debounce(this.setDropdownBackdropHeight, 250));
    }

    this.navigationItem = this.dropdownMenu.find('[data-behaviour~="navigation-item"]');

    this.dropdownMenu.find(".title-expander").on("click", this.menuExpanderClicked);
  }

  dropdownBackdropClicked(event) {
    event.stopPropagation();
    if (event.target === this.dropdownBackdrop[0]) {
      return this.closeMenu();
    }
  }

  menuExpanderClicked(event) {
    const menuList = jQuery(event.target).closest(this.navigationItem);

    if (menuList.closest("nav.navigation-group").attr("id") === "main_mobile") {
      menuList.siblings('[data-behaviour~="navigation-item"]').removeClass("active");
    }

    return this.toggleMenuListItems(menuList);
  }

  openMenu() {
    super.openMenu(...arguments);
    return this.setDropdownBackdropHeight();
  }

  setDropdownBackdropHeight() {
    if (!this.menuOpen) {
      return;
    }

    if (this.options.dropdownBackdrop && this.dropdownBackdrop.css("position") === "fixed") {
      return this.dropdownBackdrop.css({
        top: this.getOffset() + "px",
        height: "calc(100% - " + this.getOffset() + "px)",
      });
    }
  }

  toggleMenuListItems(menuList) {
    return menuList.toggleClass("active");
  }

  getOffset() {
    return this.el.offset().top - jQuery(document).scrollTop();
  }
};
